export default __webpack_public_path__ + "static/media/avatar-default.e234af1a.svg";